import { Avatar } from 'antd'
import { useNavigate } from 'react-router'
import styled from 'styled-components'

const StyledAvatar = styled(Avatar)`
  &.ant-avatar {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--color-primary-101);
  }
`

const StyledAvatarContainer = styled.div`
  color: var(--color-primary-108);
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-primary-103);
  border-radius: 50%;
  font-weight: 700;
  font-size: 2.4rem;
  overflow: hidden;
  img {
    width: 80px;
  }
`
export const ImageAvatar = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  margin: 0 auto;
`
interface IProps {
  img?: string
  value?: string
  path?: string
}

const AvatarImg = (props: IProps) => {
  const { img, value, path } = props
  const navigate = useNavigate()
  const nameArray = value?.trim()?.split(' ') || ['']
  let avatarText = ''
  avatarText = nameArray?.[0]?.[0]
  if (nameArray?.length > 1) {
    avatarText += nameArray[nameArray?.length - 1]?.[0]
  }
  const handleOnClick = () => {
    if (path) {
      navigate(path)
    }
  }
  return (
    <ImageAvatar>
      <StyledAvatar
        onClick={handleOnClick}
        icon={
          <StyledAvatarContainer>
            {img ? <img src={img} alt="" /> : avatarText?.toUpperCase()}
          </StyledAvatarContainer>
        }
      />
    </ImageAvatar>
  )
}

export default AvatarImg
